import React from "react";
import { bool } from "prop-types";

import * as S from "./styled";

const TextArea = React.forwardRef((props, ref) => (
  <S.TextArea ref={ref} {...props} />
));

TextArea.propTypes = {
  isValid: bool
};

TextArea.defaultProps = {
  isValid: true
};

export default TextArea;
